// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\api\orders\orders.hooks.js

import { useQuery, useMutation } from '@tanstack/react-query';
import { OrdersService } from './orders.service';

/**
 * Hook to fetch all orders for a customer
 */
export const useGetOrdersByCustomer = (customerId) => {
  return useQuery({
    queryKey: ['ordersList', customerId],
    queryFn: async () => {
      const response = await OrdersService.getOrdersByCustomer(customerId);
      return response?.data || response;
    },
    enabled: !!customerId,
    staleTime: 1000 * 60 * 2,
  });
};

/**
 * Hook to fetch single order details by ID
 */
export const useGetOrderById = (orderId) => {
  return useQuery({
    queryKey: ['orderDetails', orderId],
    queryFn: async () => {
      const response = await OrdersService.getOrderById(orderId);
      return response?.data || response;
    },
    enabled: !!orderId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetOrderDetails = useGetOrderById;

export const useGetInvoicesByOrderId = () => {
  return useMutation({
    mutationFn: (orderId) => OrdersService.getInvoicesByOrderId(orderId),
  });
};

export const useCancelOrder = () => {
  return useMutation({
    mutationFn: (payload) => OrdersService.cancelOrder(payload),
  });
};

export const useRequestReturn = () => {
  return useMutation({
    mutationFn: (formData) => OrdersService.requestReturn(formData),
  });
};

export const useGetIssueReasons = (type = 'issues') => {
  return useQuery({
    queryKey: ['returnReasons', type],
    queryFn: async () => {
      const response = await OrdersService.getReturnReasons(type);
      const data = response?.data || response;
      return Array.isArray(data) ? data : Array.isArray(data?.[0]) ? data[0] : [];
    },
    staleTime: 1000 * 60 * 30,
  });
};

// Alias export to resolve both hook names safely
export const useGetReturnReasons = useGetIssueReasons;

export const useCreateCase = () => {
  return useMutation({
    mutationFn: (payload) => OrdersService.createCase(payload),
  });
};